import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "@phosphor-icons/react";
import { api, fileUrl, trackPage } from "../lib/api";
import { useLang } from "../i18n";

export default function BeritaDetail() {
    const { id } = useParams();
    const { t } = useLang();
    const [article, setArticle] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        trackPage(`/berita/${id}`);
        api.get(`/news/${id}`)
            .then((r) => setArticle(r.data))
            .catch(() => setArticle(false));
    }, [id]);

    if (article === null) {
        return <div className="min-h-screen bg-white" data-testid="article-loading" />;
    }

    if (article === false) {
        return (
            <div className="min-h-screen bg-white text-neutral-900 flex flex-col items-center justify-center gap-6" data-testid="article-not-found">
                <p className="font-display uppercase text-3xl">{t.article_notfound}</p>
                <Link to="/" className="text-xs uppercase tracking-[0.25em] text-racing-red" data-testid="article-back-link">
                    {t.back_home}
                </Link>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-white text-neutral-900" data-testid="article-page">
            <div className="max-w-3xl mx-auto px-6 py-16 md:py-24">
                <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}>
                    <Link
                        to="/"
                        data-testid="article-back-link"
                        className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-racing-muted hover:text-neutral-900 transition-colors duration-300"
                    >
                        <ArrowLeft size={16} weight="bold" /> {t.back}
                    </Link>

                    <p className="mt-10 text-xs uppercase tracking-[0.25em] text-racing-red" data-testid="article-category">
                        {article.category} · {article.date}
                    </p>
                    <h1 className="mt-4 font-display uppercase text-3xl sm:text-4xl lg:text-5xl leading-tight" data-testid="article-title">
                        {article.title}
                    </h1>

                    {article.image_url && (
                        <img
                            src={fileUrl(article.image_url)}
                            alt={article.title}
                            className="mt-10 w-full h-[280px] md:h-[420px] object-cover"
                            style={{ clipPath: "polygon(0 0, 100% 0, 100% 92%, 95% 100%, 0 100%)" }}
                            data-testid="article-image"
                        />
                    )}

                    <div className="mt-10 space-y-6" data-testid="article-content">
                        {article.content.split("\n").filter(Boolean).map((p, i) => (
                            <p key={i} className="text-base md:text-lg font-light text-neutral-900/80 leading-relaxed">
                                {p}
                            </p>
                        ))}
                    </div>
                </motion.div>
            </div>
        </div>
    );
}
